import * as angular from 'angular';

// Click handler directive for automatically orienting uib-dropdowns
// upwards if they're too close to the bottom of their scroll pane
//
// Note that opening upwards can make it even more likely to be cut
// off by a scroll container, so you may need dropdown-append-to-body
// in conjunction with this. (I wanted to make it required but it's
// not supported by fucking ng-bootstrap yet.)
export function dropdownAutoOrient(): angular.IDirective {
  return {
    restrict: 'A',
    link: ($scope, elem, attrs) => {
      const container = elem.closest('[uib-dropdown]');
      const toggle = container.find('.dropdown-toggle');
      toggle.on('click.dropdownAutoOrient', (e) => orientMenuNear(toggle, elem));

      $scope.$on('$destroy', () => toggle.off('click.dropdownAutOrient'));
    },
  };
}

const DROPDOWN_MARGIN = 50;
const BOOTSTRAP_DROPDOWN_OVERLAP = 10;

function orientMenuNear($toggler, $dropdown) {
  const bottomOverlap = getOverlap(
    function dropdownBottom() {
      // infer {$dropdown} bottom position instead of measuring it
      // because the real bottom position will change
      return bottom($toggler[0]) + $dropdown.height();
    },
    bottom(document.body),
    DROPDOWN_MARGIN
  );

  if (bottomOverlap > 0) {
    setMenuAbove($dropdown, $toggler);
  } else {
    setMenuBelow($dropdown);
  }
}

function getOverlap(targetPosition, parentPosition, buffer) {
  targetPosition = 'function' === typeof targetPosition ? targetPosition() : targetPosition;
  parentPosition = 'function' === typeof parentPosition ? parentPosition() : parentPosition;
  buffer = buffer || 0;
  return targetPosition + buffer - parentPosition;
}

function bottom(el) {
  let bottom = el.getBoundingClientRect().bottom;
  if (el === document.body) {
    bottom = Math.max(bottom, $(window).height());
  }
  return bottom;
}

function setMenuAbove($dropdown, $toggler) {
  marginTop($dropdown, -($dropdown.height() + BOOTSTRAP_DROPDOWN_OVERLAP + $toggler.height()) + 'px');
}

function setMenuBelow($dropdown) {
  marginTop($dropdown, 'inherit');
}

function marginTop($el, value) {
  $el.css('marginTop', value);
}
